<template>
    <div class="review-block">
        <div class="row q-n-a question">
            <div class="icon">Q</div>
            {{ data.question }}是含醣食物嗎？
        </div>
        <div class="row q-n-a answer" :class="{ true: data.answer }">
            <div class="icon">A</div>
            {{ data.answer ? "是" : "否" }}
        </div>
        <div class="row description">{{ data.hint }}</div>
    </div>
</template>

<script>
export default {
    props: {
        data: Object,
    },
};
</script>

<style lang="scss" scoped>
.review-block {
    font-weight: bold;
    width: 90%;
    margin: 15px auto;
    border-bottom: 1px solid #57a2e7;
    .icon {
        font-size: 18px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        color: #fff;
    }
    .row {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }
    .q-n-a {
        font-size: 20px;
    }
    .question .icon {
        background-color: #57a2e6;
    }

    .answer {
        color: #ef874f;
        .icon {
            background-color: #ef874f;
        }
        &.true {
            color: #5ac892;
            .icon {
                background-color: #5ac892;
            }
        }
    }

    .description {
        padding: 5px 10px;
        border-radius: 8px;
        background-color: #ebebeb;
    }
}
</style>
